<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-sm-12">
        <!-- <div class="row">
          <div class="col-md-12">
            <ul>
              <li *ngFor="let convenio of convenios">
                <strong>Convenio:</strong> {{ convenio.nombreConvenio }}
              </li>
            </ul>
          </div>
        </div> -->
        <!---FILTROS-->
        <!--
        <div class="row">
          <div class="row">
            <div class="col-6 col-md-3 col-xs-6 col-sm-6 col-lg-3">
              <div class="mb-3">
                <label class="control-label">Sede</label>
                <ng-select
                  [items]="sedes"
                  bindValue="$id"
                  bindLabel="sede"
                  placeholder="Seleccione"
                  appendTo="body"
                  [multiple]="false"
                  (change)="filtrarDatos()"
                  [(ngModel)]="searchSede"
                >
                </ng-select>
              </div>
            </div>
            <div class="col-6 col-md-3 col-xs-6 col-sm-6 col-lg-3">
              <div class="mb-3">
                <label class="control-label">Servicios</label>
                <ng-select
                  [items]="servicios"
                  bindValue="$id"
                  bindLabel="servicio"
                  placeholder="Seleccione"
                  appendTo="body"
                  [multiple]="false"
                  [(ngModel)]="searchServicio"
                  (change)="filtrarDatos()"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.servicio }}
                  </ng-template>
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-search="searchTerm"
                  >
                    {{ item.servicio }} | {{ item.modalidad }} |
                    {{ item.consulta }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-6 col-md-3 col-xs-6 col-sm-6 col-lg-3">
              <div class="mb-3">
                <label class="control-label">Especialidad</label>
                <ng-select
                  [items]="especialidades"
                  bindValue="$id"
                  bindLabel="especialidad"
                  [(ngModel)]="searchEspecialidad"
                  placeholder="Seleccione"
                  appendTo="body"
                  [multiple]="false"
                  (change)="filtrarDatos()"
                >
                </ng-select>
              </div>
            </div>
            <div class="col-6 col-md-3 col-xs-6 col-sm-6 col-lg-3">
              <div class="mb-3">
                <label class="control-label">Tipo Especialista</label>
                <ng-select
                  [items]="tiposEspecialistas"
                  bindValue="id"
                  bindLabel="especialidad"
                  [(ngModel)]="searchTipoEspecialista"
                  placeholder="Seleccione"
                  appendTo="body"
                  [multiple]="false"
                  (change)="filtrarDatos()"
                >
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />-->

    <div class="d-flex justify-content-center">
      <div class="card-body max-ancho">
        <div class="row" data-masonry='{"percentPosition ": true }'>
          @for (data of especialistasFiltrados; track data.$id) {
            @if (data.servicios?.length > 0) {
              <div class="col-xs-12 col-sm-6 col-md-4 ng-star-inserted mb-4">
                <div class="card h-100 border-box">
                  <div class="image-container">
                    <img src="{{ data.foto }}" alt="{{ data.nombre }}" />
                  </div>
    
                  <div class="m-3">
                    <h5 class="nombre-title">{{ data.nombre }}</h5>
                    <p class="nombre-subtitle">{{ data.perfil.especialidad }}</p>
    
                    <!-- Especialidades-->
                    <p class="card-text m-1" *ngIf="data.especialidades.length > 0">
                      <i class="dripicons-trophy"></i> Especialidades
                    </p>
                    <ul>
                      <li *ngFor="let especialidad of data.especialidades">
                        {{ especialidad.tEspecialidad.especialidad }} -
                        {{ especialidad.idPoblacion.descripcion }}
                      </li>
                    </ul>
    
                    <app-expandable-text
                      [text]="data.descripcion"
                      [maxLength]="100"
                    ></app-expandable-text>
    
                    <p>
                      <a
                        href="javascript: void(0);"
                        (click)="showAgenda(data)"
                        class="btn_alfinal btn btn-primary waves-effect waves-light btn-rounded"
                      >
                        <i
                          style="margin-right: 9px; top: 40px; position: sticky"
                        ></i>
                        Agenda tu cita
                      </a>
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            }
          }
        </div>
    
        <!-- Spinner al final -->
        <div class="text-center my-4" *ngIf="spinner">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
